enum PaymentTypes {
  Account = 'ACCOUNT',
  Credit = 'CREDIT',
  Subsidy = 'SUBSIDY',
}

export default PaymentTypes;
